module.exports = __webpack_public_path__ + "img/滑块2.fd6a964a.jpg";